import React, {Component} from 'react';

class AlertTimeBook extends Component {
    constructor(props) {
        super(props)
        this.handleAlertTimeBook = this.handleAlertTimeBook.bind(this);
    }

    handleAlertTimeBook() {
        this.props.inactiveAlertTimeBook(false)
    }

    render() {
        return (
            <div id="popup-hair" className="slickModal isActive"
                 style={{"transition-duration": "0.4s"}}>
                <div className="slickOverlay closeModal setSlickCookie"
                     style={{'background': 'rgba(0, 0, 0, 0.85098)', 'transition-duration': '0.4s'}}></div>
                <div className="slickWindow center animated" style={{
                    'width': '330px',
                    'height': '200px',
                    'box-shadow': 'rgba(0, 0, 0, 0.4) 0px 0px 20px 0px',
                    'background': 'rgb(255, 255, 255)',
                    'border-radius': '0px',
                    'margin': 'auto',
                    'padding': '0px',
                    'animation-duration': '0.4s',
                    'animation-delay': '0.2'
                }}>
                    <div className="slickCloseBtn close closeModal icon"
                         onClick={this.handleAlertTimeBook}
                    ></div>
                    <div className="wrap">
                        <div className="popup-icon"></div>
                        <h2>Alert</h2>
                        <div className="stylulist">
                            <strong>We cannot guarantee appointments scheduled within 3 hours, but our team will do its
                                best and
                                contact you to confirm</strong>
                        </div>
                    </div>
                    <div className="cta" style={{'display': 'none'}}>
                        <span className="closeModal">Close me</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default AlertTimeBook;


/** WEBPACK FOOTER **
 ** ./src/components/AlertTimeBook.js
 **/